import React from "react";

import Label from "./Label";
import styles from "./index.module.scss";

interface Props {
  boxSize?: "mediumBox" | "smallBox";
  label: string;
  labelSize?: "medium" | "small";
  required?: boolean;
}

class BoxLabel extends React.PureComponent<Props> {
  public render() {
    const { boxSize, children, label, labelSize } = this.props;

    return (
      <div className={styles.wrapper}>
        <Label label={label} boxSize={boxSize} labelSize={labelSize} />
        <div className={styles.contentContainer}>{children}</div>
      </div>
    );
  }
}

export { BoxLabel };
export { default as ContentRow } from "./ContentRow";
export { default as ContentsBox } from "./ContentsBox";
export { default as Label } from "./Label";
